<template>
  <div class="tabbable-line">
    <Tabs
      v-show="!guest"
      :default-value="TAB_GALLERY"
    >
      <TabsList>
        <TabsTrigger
          :value="TAB_GALLERY"
          variant="fill"
        >
          Gallery
        </TabsTrigger>
        <button
          v-if="teamHasFeature(constants.GLOBAL.FEATURE_CUSTOM_VB)"
          :class="tabsTriggerVariants({ variant: 'fill' })"
          type="button"
          @click="$refs.teamAssetPickerRef.show()"
        >
          Your Photos
        </button>
        <a
          v-else
          :class="tabsTriggerVariants({ variant: 'fill' })"
          class="tw:cursor-not-allowed tw:text-foreground"
          :href="router('web.subscription', { upgrade_source: constants.GLOBAL.FEATURE_CUSTOM_VB })"
          target="_blank"
        >
          Your Photos
          <i class="fal fa-lock ml-2" />
        </a>
      </TabsList>
      <TabsContent
        :value="TAB_GALLERY"
      >
        <div ref="system-list" style="max-height: 300px; overflow-y: scroll;">
          <div class="flexbin flexbin-margin">
            <CustomTooltip v-for="(item, key) in images.system.data" :key="key" :text="item.title">
              <div :class="{ selected: item.link === modelValue }">
                <img :src="item.link" class="cursor-pointer" crossorigin="anonymous" @click="loadVbImg(item.link)">
              </div>
            </CustomTooltip>
          </div>
        </div>
      </TabsContent>
    </Tabs>

    <TeamAssetPicker
      v-if="spark.hasTeam()"
      ref="teamAssetPickerRef"
      v-model="selectedVirtualBackgroundTeamAsset"
      :category="constants.App_Models_TeamAsset.CATEGORY_VIRTUAL_BACKGROUND"
      helper-text="PNG or JPG, 1920 × 1080 recommended, up to 5 MB"
    />
  </div>
</template>

<script>
import axios from 'axios'
import $ from 'jquery'
import Store from 'store'
import CustomTooltip from '@/components/custom-tooltip.vue'
import { Tabs, TabsContent, TabsList, TabsTrigger, tabsTriggerVariants } from '@/shadcn/components/ui/tabs'
import StorageKeys from '../../../common/storage-keys'
import TeamAssetPicker from '../../common/team-asset-picker/team-asset-picker.vue'

export default {
  name: 'VirtualBackgroundImagePicker',
  components: {
    TabsContent,
    TabsTrigger,
    TabsList,
    Tabs,
    TeamAssetPicker,
    CustomTooltip,
  },
  props: {
    guest: {
      type: Boolean,
      default: false,
    },
    modelValue: {},
    visible: {},
  },
  emits: ['update:modelValue'],
  setup() {
    const TAB_GALLERY = 'gallery'

    return {
      TAB_GALLERY,
    }
  },
  data() {
    return {
      images: {
        system: {
          loading: false,
          perPage: 10,
          data: [],
          all: [],
        },
      },
      uploading: false,
      firstLoad: true,
      selectedVirtualBackgroundTeamAsset: null,
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal && this.firstLoad) {
          this.loadSystemImages()
          this.firstLoad = false
        }
      },
      immediate: true,
    },
    selectedVirtualBackgroundTeamAsset(newVal) {
      if (newVal) {
        this.loadVbImg(newVal.real_url)
      }
    },
  },
  mounted() {
    const lastUrl = Store.get(StorageKeys.VIRTUAL_BACKGROUND_URL)

    if (lastUrl) {
      this.loadVbImg(lastUrl)
    }

    const $list = $(this.$refs['system-list'])
    $list.on('scroll', () => {
      if ($list.scrollTop() + $list.innerHeight() >= $list[0].scrollHeight) {
        if (this.images.system.loading) {
          return
        }

        if (this.images.system.all.length === 0) {
          return
        }

        this.images.system.loading = true
        this.images.system.data = this.images.system.data.concat(this.images.system.all.splice(0, this.images.system.perPage))
        this.images.system.loading = false
      }
    })
  },
  methods: {
    tabsTriggerVariants,
    loadVbImg(url) {
      Store.set(StorageKeys.VIRTUAL_BACKGROUND_URL, url)
      this.$emit('update:modelValue', url)
    },
    loadSystemImages() {
      axios.get(this.router('api.configuration.show', { key: this.constants.App_Models_Setting.SETTING_VIRTUAL_BACKGROUND_IMAGES }))
        .then((resp) => {
          this.images.system.all = resp.data
          this.images.system.data = this.images.system.all.splice(0, this.images.system.perPage * 2)

          if (!this.modelValue && this.images.system.data.length > 0) {
            this.loadVbImg(this.images.system.data[0].link)
          }
        })
    },
  },
}
</script>
